import React, { useState } from "react";
import { counterData } from "./data";

const AlphaherdCounterSection = () => {
  const [timer, setTimer] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const countDownDate = new Date("June 16, 2022 15:37:25").getTime();
  const timerFunc = setInterval(() => {
    const now = new Date().getTime();
    const distance = countDownDate - now;
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    setTimer({
      ...timer,
      days,
      hours,
      minutes,
      seconds,
    });
    if (distance < 0) {
      clearInterval(timerFunc);
    }
  }, 1000);
  return (
    <section className="alpha_counter_section">
      <div className="container">
        <div className="section_wrapper">
          <div className="row">
            <div className="col-md-12">
              <div className="image_text">
                {counterData.map((d, i) => (
                  <img
                    src={d}
                    key={i + 1}
                    data-aos={`${((i + 1) % 2) === 0 ? "fade-up" : "fade-down"}`}
                    data-aos-delay="500"
                    data-aos-duration="5000"
                    data-aos-once="true"
                    data-aos-easing="ease-in-out"
                    alt="imgtext"
                    width="100%"
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="timer_box">
                <div
                  className="timer"
                  data-aos="fade-up"
                  data-aos-delay="500"
                  data-aos-duration="5000"
                  data-aos-once="true"
                  data-aos-easing="ease-in-out"
                >
                  <span>{timer.days}</span>
                  days
                </div>
                <div
                  className="timer"
                  data-aos="fade-up"
                  data-aos-delay="700"
                  data-aos-duration="5000"
                  data-aos-once="true"
                  data-aos-easing="ease-in-out"
                >
                  <span>{timer.hours}</span>
                  hours
                </div>
                <div
                  className="timer"
                  data-aos="fade-up"
                  data-aos-delay="900"
                  data-aos-duration="5000"
                  data-aos-once="true"
                  data-aos-easing="ease-in-out"
                >
                  <span>{timer.minutes}</span>
                  minutes
                </div>
                <div
                  className="timer"
                  data-aos="fade-up"
                  data-aos-delay="1100"
                  data-aos-duration="5000"
                  data-aos-once="true"
                  data-aos-easing="ease-in-out"
                >
                  <span>{timer.seconds}</span>
                  seconds
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AlphaherdCounterSection;
